var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-to-store-wrapper"},[_c('router-link',{staticClass:"back-to-store",attrs:{"to":"/shop","exact":""}},[_vm._v("Back to Store")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }